import { render } from "./Progressbar.vue?vue&type=template&id=42742020&scoped=true"
import script from "./Progressbar.vue?vue&type=script&lang=js"
export * from "./Progressbar.vue?vue&type=script&lang=js"

import "./Progressbar.vue?vue&type=style&index=0&id=42742020&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-42742020"

export default script